import html2canvas from 'html2canvas';

/**
 * Captures an HTML element as a base64 image
 * @param element - The HTML element to capture
 * @param options - Optional capture options
 * @returns Promise resolving to base64 data URL
 */
export async function captureElementAsImage(
  element: HTMLElement,
  options?: {
    scale?: number;
    backgroundColor?: string;
  }
): Promise<string> {
  const canvas = await html2canvas(element, {
    scale: options?.scale ?? 2,
    useCORS: true,
    logging: false,
    backgroundColor: options?.backgroundColor ?? '#ffffff',
  });

  return canvas.toDataURL('image/png');
}
